import { h } from 'preact';
import { useState, useRef, useCallback, useEffect } from 'preact/hooks';
import { debounce } from '../debounce';

export function TextFieldEntry({
  id,
  label,
  value,
  onChange,
  disabled = false,
  validate,
  description,
  placeholder,
  debounce: debounceOpt = false,
  type = 'text',
}) {
  const [error, setError] = useState(null);
  const debouncedRef = useRef(null);

  // Build a (possibly debounced) change handler
  const handleChange = useCallback(
    (val) => {
      if (validate) {
        const err = validate(val);
        setError(err || null);
        if (err) return;
      }
      onChange(val);
    },
    [onChange, validate],
  );

  // Create / tear-down the debounced wrapper when the option changes
  useEffect(() => {
    if (debounceOpt) {
      const delay = typeof debounceOpt === 'number' ? debounceOpt : 300;
      debouncedRef.current = debounce(handleChange, delay);
      return () => debouncedRef.current.cancel();
    }
    debouncedRef.current = null;
  }, [debounceOpt, handleChange]);

  const onInput = (e) => {
    const val = e.target.value;
    // Immediate validation feedback even when debouncing
    if (validate) {
      setError(validate(val) || null);
    }
    if (debouncedRef.current) {
      debouncedRef.current(val);
    } else {
      handleChange(val);
    }
  };

  return (
    <div class={`epx-entry epx-text-field${error ? ' has-error' : ''}`}>
      <label class="epx-entry-label" htmlFor={id}>{label}</label>
      <input
        id={id}
        type={type}
        class="epx-entry-input"
        value={value || ''}
        placeholder={placeholder || ''}
        disabled={disabled}
        onInput={onInput}
      />
      {error && <div class="epx-entry-error">{error}</div>}
      {description && <div class="epx-entry-description">{description}</div>}
    </div>
  );
}
